import { render } from "./Crowd.vue?vue&type=template&id=8c9a56ac&ts=true"
import script from "./Crowd.vue?vue&type=script&lang=ts"
export * from "./Crowd.vue?vue&type=script&lang=ts"

const cssModules = {}
import style0 from "@/styles/components/card.scss?vue&type=style&index=0&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__